const dataLayerMixin = {
  computed: {
    currencyCode() {
      return 'EUR';
    },

    searchTerm() {
      let searchTerm = decodeURIComponent(window.location.href.split('q=')[1]);
      if (searchTerm.indexOf("&") !== -1) {
        searchTerm = searchTerm.split("&")[0];
      }
      return searchTerm;
    },
    configuratorProductId() {
      return 'B0007649';
    },
    cartContent() {
      const _this = this;
      let cartContent = [];
      const configuratorCategoryName = this.$t('configurator.category.description');
      if (this.cart && this.cart.shipmentPositions?.length) {
        this.cart.shipmentPositions
          .flatMap(shipmentPos => shipmentPos.positions)
          .forEach(function (position) {
            let image = position.image !== null ? position.image.src : null;
            cartContent.push({
              id: position.itemId,
              itemGroupId: position.parentId,
              name: position.name,
              pricePerItemNet: _this.priceToFloat(position.price),
              categoryId: position.categoryId,
              categoryName: position.categoryName,
              variant: _this.sortVariant(position.variations),
              quantity: position.quantity,
              primaryImageUrl: _this.getMainFormatImage(image)
            })
          });
      }
      if (this.cart && this.cart.configuratorPositions?.length) {
        this.cart.configuratorPositions
          .forEach(function (position) {
            let image = position.image !== null ? position.image.src : null;
            cartContent.push({
              id: '',
              itemGroupId: _this.configuratorProductId,
              name: position.name,
              pricePerItemNet: _this.priceToFloat(position.singlePrice),
              categoryId: 0,
              categoryName: configuratorCategoryName,
              variant: `${position.color}, ${position.quality}`,
              quantity: position.quantity,
              primaryImageUrl: _this.getMainFormatImage(image)
            })
          });
      }
      return cartContent;
    },
  },
  methods: {
    priceToFloat(price) {
      return parseFloat(price.replace(/\s+.*$/, '')
        .replace('.', '')
        .replace(',', '.'));
    },
    trackEvent(trackingData) {
      if (this.$gtm.enabled()) {
        window.dataLayer?.push(trackingData);
      }
    },
    sortVariant(variants) {
      if (!variants) {
        return '';
      }
      return variants
        .sort()
        .join(', ');
    },
    getMainFormatImage(image) {
      let mainImage = '';
      const mainFormat = '/webpdmain/';
      if (image !== undefined && image !== null) {
        mainImage = image.replace('/webplist/', mainFormat)
          .replace('/basket/', mainFormat)
          .replace('/webpdthumb/', mainFormat)
          .replace('/webpdzoom/', mainFormat)
          .replace('/tsmall/', mainFormat)
          .replace('/tlarge/', mainFormat)
          .replace('/master/', mainFormat);
      }
      return mainImage;
    }
  }
};

export default dataLayerMixin;
